export class PasswordMatchOptionModel {
  match = false;
  required = false;
  constructor(match: boolean = false, required: boolean = false) {
    this.match = match;
    this.required = required;
  }
}
